import React, { useCallback, useState } from 'react';
import { SummaryContext, SummarySetterContext, SummaryState, TabProps } from './summaryContext';
import { CardTW } from '../../../tailwindComponents/CardTW/CardTW';
import { TextInputTW } from '../../../tailwindComponents/textInputTW/TextInputTW';
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import { SectionTabs } from './SectionTabs';

interface SummaryProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  showFilter?: boolean;
  tabData?: TabProps[];
  defaultPlaceholder?: string;
}

// a Summary shows its children, SummaryItems and provides a SummaryFilterContext.
// The Summary provides a TextInput, whose value is controlled by a Context
export const Summary: React.FC<SummaryProps> = ({
  children,
  title,
  tabData,
  defaultPlaceholder,
  showFilter = true,
}) => {
  const [summaryState, setSummaryState] = useState<SummaryState>({
    filterText: '',
    activeTab: tabData?.at(0),
  });
  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSummaryState((prevState) => ({ ...prevState, filterText: event.target.value }));
    },
    [setSummaryState]
  );

  return (
    <CardTW title={title}>
      <SummaryContext.Provider value={summaryState}>
        <SummarySetterContext.Provider value={setSummaryState}>
          <div className={'flex flex-col gap-2'}>
            <SectionTabs tabs={tabData} />
            {showFilter && (
              <TextInputTW
                value={summaryState.filterText}
                onChange={onChange}
                placeholder={summaryState.activeTab?.placeholder ?? defaultPlaceholder ?? 'Search'}
                LeftIcon={MagnifyingGlassIcon}
              />
            )}
          </div>
          <>{children}</>
        </SummarySetterContext.Provider>
      </SummaryContext.Provider>
    </CardTW>
  );
};
